import { useReducer } from 'react';
import Constant from '../../constants';
import reducer from './profile-suggestions-reducer';
import styles from './ProfileSuggestions.module.scss';
import addFriendIcon from '../../images/addFriend.svg';
import alphaBlack from '../../images/alpha-black.svg';
import omegaBlack from '../../images/omega-black.svg';
import { profileSuggestions } from '../../data';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

const initialState = {
  suggestedProfiles: profileSuggestions,
};
const ProfileSuggestions = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <aside className={styles.suggestions}>
      <h3 className={styles.suggestionText}>Suggestions</h3>
      <h3 className={styles.viewAll}>View all</h3>
      {state.suggestedProfiles.map((profile, index) => {
        return (
          <main
            className={
              index < state.suggestedProfiles.length - 1
                ? styles.suggestion
                : styles.lastSuggestion
            }
            key={profile.id}
          >
            <article className={styles.profileImg}>
              <img src={profile.imgUrl} />
            </article>
            <article className={styles.profileDetails}>
              <h4 className={styles.profileName}>
                {profile.name}{' '}
                <img
                  className={
                    profile.type === 'alpha' ? styles.alphaIcn : styles.omegaIcn
                  }
                  src={profile.type === 'alpha' ? alphaBlack : omegaBlack}
                />
              </h4>
              <p>
                {profile.university} {profile.designation}
              </p>
              <img className={styles.addFriendIcon} src={addFriendIcon} />
            </article>
          </main>
        );
      })}
      <h3 className={styles.viewMore}>View more...</h3>
    </aside>
  );
};

export default ProfileSuggestions;
